import { JSX } from "react";
import {
    InputField,
    UserSelectionCard,
    Button,
} from "@hatch-digital-nl/abs-storybook/legacy";
import SearchIcon from "../../../../../common/images/search.svg";
import { useEstablishmentId } from "../../../../../common/utils/useEstablishmentId";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useGetEmployeesQuery } from "../../../../../common/api/employee";
import { StatusEnum } from "../../../../../common/enums/StatusEnum";
import { debounce } from "../../../../../common/utils/debounce";
import {
    setFormStep,
    setSearchEmployees,
    setSelectedEmployees,
} from "../../../CreateCertificateModalSlice";
import Skeleton from "react-loading-skeleton";
import { EmployeeInterface } from "../../../../../common/interfaces/EmployeeInterface";
import { getFunctionGroupLabel } from "../../../../../common/utils/getFunctionGroupLabel";
import { getUserFullName } from "../../../../../common/utils/getUserFullName";
export const CreateFormContentStepOne = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { selectedEmployees, searchEmployees } = useAppSelector(
        (state) => state.createCertificateModal,
    );
    const {
        data: employeeData,
        isLoading: employeeIsLoading,
        isFetching: employeeIsFetching,
    } = useGetEmployeesQuery({
        items_per_page: 9999,
        filter: {
            search: searchEmployees,
            establishment_id: useEstablishmentId(),
            status: StatusEnum.ACTIVE,
        },
    });

    return (
        <div className={"c-create-certificates-modal__content"}>
            <div className={"c-create-certificates-modal__content__header"}>
                <h3>Selecteer medewerker(s)</h3>
                <InputField
                    placeHolder={"Zoeken..."}
                    iconRight={SearchIcon}
                    onChange={debounce((value: string) => {
                        dispatch(setSearchEmployees(value));
                    })}
                />
            </div>
            <div className={"c-create-certificates-modal__content__employees"}>
                {employeeIsLoading || employeeIsFetching ? (
                    <Skeleton
                        containerClassName={
                            "c-create-certificates-modal__content__employees c-create-certificates-modal__content__employees--skeleton"
                        }
                        inline={true}
                        count={3}
                    />
                ) : (
                    <>
                        {employeeData?.data.map((employee) => {
                            const isActive = selectedEmployees.some(
                                (selected: EmployeeInterface) =>
                                    selected.id === employee.id,
                            );

                            return (
                                <UserSelectionCard
                                    key={employee.id}
                                    className={
                                        "c-create-certificates-modal__content__employees__employee"
                                    }
                                    title={
                                        getUserFullName(employee.user) ?? "-"
                                    }
                                    description={getFunctionGroupLabel(
                                        employee?.function_groups,
                                    )}
                                    active={isActive}
                                    onClick={() => {
                                        if (isActive) {
                                            dispatch(
                                                setSelectedEmployees(
                                                    selectedEmployees.filter(
                                                        (
                                                            selected: EmployeeInterface,
                                                        ) =>
                                                            selected.id !==
                                                            employee.id,
                                                    ),
                                                ),
                                            );
                                        } else {
                                            dispatch(
                                                setSelectedEmployees([
                                                    ...selectedEmployees,
                                                    employee,
                                                ]),
                                            );
                                        }
                                    }}
                                />
                            );
                        })}
                    </>
                )}
            </div>
            <div className={"c-create-certificates-modal__content__button"}>
                <Button
                    variant={"primary"}
                    disabled={selectedEmployees.length === 0}
                    onClick={
                        selectedEmployees.length > 0
                            ? () => {
                                  dispatch(setFormStep(2));
                              }
                            : undefined
                    }
                >
                    Datum behaald & documenten
                </Button>
            </div>
        </div>
    );
};
